import Post from "../Post";
import type { TGenericPostsQuery } from "../typings";
import cls from "./styles.module.css";

type TPageProps = {
  page: TGenericPostsQuery;
};
const Page = (props: TPageProps) => {
  return (
    <>
      {props.page.posts.map((post) => (
        <Post key={post.id} data={post} />
      ))}
    </>
  );
};

type TPostsListProps = {
  pages: TGenericPostsQuery[];
};

const PostsList = (props: TPostsListProps) => {
  return (
    <ul className={cls.root}>
      {props.pages.map((page, idx) => (
        <Page page={page} key={idx} />
      ))}
    </ul>
  );
};
export default PostsList;
